import { path } from 'ramda';

export const calendarId = path(['match', 'params', 'id']);
